import { signal, Signal } from '@angular/core';

/**
 * Represents a class that handles unsaved changes in a form.
 * Subclasses report whether their form holds unsaved changes; this class prompts the user with a
 * modal dialog when there are, and resolves the pending navigation once they save or discard.
 */
export abstract class FormUnsavedChangesHandler {
	/** Only the form itself knows what counts as a change, so every subclass must answer this. */
	abstract readonly hasUnsavedChanges: Signal<boolean>;

	overlayOpen = signal(false);

	private deactivationResolver: ((discard: boolean) => void) | null = null;

	canDeactivate(): Promise<boolean> | boolean {
		if (this.hasUnsavedChanges()) {
			this.overlayOpen.set(true);
			return new Promise<boolean>((resolve) => (this.deactivationResolver = resolve));
		}
		return true;
	}

	closeModal() {
		this.resolveDeactivation(false);
		this.overlayOpen.set(false);
	}

	protected resolveDeactivation(discard: boolean) {
		this.deactivationResolver?.(discard);
		this.deactivationResolver = null;
	}
}
